import { render, staticRenderFns } from "./d-paging.vue?vue&type=template&id=5801ae30&scoped=true&"
import script from "./d-paging.vue?vue&type=script&lang=js&"
export * from "./d-paging.vue?vue&type=script&lang=js&"
import style0 from "./d-paging.vue?vue&type=style&index=0&id=5801ae30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5801ae30",
  null
  
)

export default component.exports